import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../app/services/auth.service';
import { AppHelperService } from '../../../app/services/app-helper.service';

@Component({
    selector: 'message-banner',
    templateUrl: './message-banner.template.html',
    styleUrls: ['./message-banner.style.scss'],
    standalone: false
})
export class MessageBanner implements OnInit{
    @Input() msgBannerData: any; //optional
    showBanner: boolean = false;


    constructor(private authService: AuthService,
        private appHelperService: AppHelperService) { }

    ngOnInit() {
        // If 'msgBannerData' is present then use this data as it is, otherwise get data from localstorage. 
        if (!this.msgBannerData) {
            let userData = this.authService.getUserData();
            this.msgBannerData = this.appHelperService.getBannerDataFromLocalStorage(userData.extUserId);
        }
        if (this.msgBannerData) {
            this.showBanner = true;
            setTimeout(() => { this.showBanner = false; }, 10000);
        }
    }
}